import { Injectable } from '@angular/core';

@Injectable({
  providedIn: "root"
})
export class Menu {
  toggled = false;

  currentParent: String = "";

  menus = [
    //old
    {
      title: "Tableau de bord",
      type: "header",
      permission: "for_all",
      header_id: "tableau_de_bord",
      current_header: ""
    },

    {
      title: "Performance",
      Url: "/dashboard/performance",
      icon: "fa fa-flash",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "tableau_de_bord",
      current_header: ""
    },

    //old

    //new
    
    {
      title: "Dashboard",
      type: "header",
      permission: "for_all",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },

    {
      title: "Personnel",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Mes performances",
          Url: "/personnel/performance",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Mes dossiers",
          Url: "/new-dashboard/personnel/dossiers-card-list",
          active: "",
          permission: "new_dashboard_personnel_dossers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Mon portefeuille",
          Url: "/new-dashboard/personnel/mon-portefeuille",
          active: "",
          permission: "new_dashboard_personnel_portefeuille",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    {
      title: "Global",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_global",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Portefeuille",
          Url: "/new-dashboard/global/portefeuille",
          active: "",
          permission: "new_dashboard_global_portefeuille",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/global/productivite",
          active: "",
          permission: "new_dashboard_global_productivite",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },
    
    {
      title: "Corporate",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_corporate",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Production",
          Url: "/new-dashboard/marche/corporate/production",
          active: "",
          permission: "new_dashboard_corporate_production",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Dossiers",
          Url: "/new-dashboard/marche/corporate/dossiers-card-list",
          active: "",
          permission: "new_dashboard_corporate_dossiers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "QOS",
          Url: "/new-dashboard/marche/corporate/quality-of-service",
          active: "",
          permission: "new_dashboard_corporate_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/marche/corporate/productivite",
          active: "",
          permission: "new_dashboard_corporate_productivite",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    {
      title: "Particulier",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_retrail",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Production",
          Url: "/new-dashboard/particulier/production",
          active: "",
          permission: "new_dashboard_particulier_production",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Dossiers",
          Url: "/new-dashboard/marche/particulier/dossiers-card-list",
          active: "",
          permission: "new_dashboard_particulier_dossiers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "QOS",
          Url: "/new-dashboard/particulier/qos",
          active: "",
          permission: "new_dashboard_particulier_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/particulier/productivite",
          active: "",
          permission: "new_dashboard_particulier_productivite",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    {
      title: "Professionnel",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_professionnel",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Production",
          Url: "/new-dashboard/professionnel/production",
          active: "",
          permission: "new_dashboard_professionnel_production",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Dossiers",
          Url: "/new-dashboard/marche/professionnel/dossiers-card-list",
          active: "",
          permission: "new_dashboard_professionnel_dossiers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "QOS",
          Url: "/new-dashboard/professionnel/qos",
          active: "",
          permission: "new_dashboard_professionnel_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/professionnel/productivite",
          active: "",
          permission: "new_dashboard_professionnel_productivite",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    {
      title: "Product program",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_product_program",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Production",
          Url: "/new-dashboard/product-program/production",
          active: "",
          permission: "new_dashboard_product_program_production",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Dossiers",
          Url: "/product-program/dossier-historique-new",
          active: "",
          permission: "new_dashboard_product_program_dossiers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "QOS",
          Url: "/new-dashboard/product-program/qos",
          active: "",
          permission: "new_dashboard_product_program_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/product-program/productivite",
          active: "",
          permission: "new_dashboard_product_program_productivite",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Synthèse",
          Url: "/product-program/dashboard/product-program",
          active: "",
          permission: "new_dashboard_product_program_synthese",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    {
      title: "Crédit",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_credit",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Production",
          Url: "/new-dashboard/credit/production",
          active: "",
          permission: "new_dashboard_credit_production",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Dossiers",
          Url: "/new-dashboard/credit/dossiers-card-list",
          active: "",
          permission: "new_dashboard_credit_dossiers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "QOS",
          Url: "/new-dashboard/credit/quality-of-service",
          active: "",
          permission: "new_dashboard_credit_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/credit/productivite",
          active: "",
          permission: "new_dashboard_credit_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    {
      title: "Juridique",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_juridique",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Production",
          Url: "/new-dashboard/direction-juridique/production",
          active: "",
          permission: "new_dashboard_juridique_production",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Dossiers",
          Url: "/new-dashboard/direction-juridique/dossiers-card-list",
          active: "",
          permission: "new_dashboard_juridique_dossiers",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "QOS",
          Url: "/new-dashboard/direction-juridique/qos",
          active: "",
          permission: "new_dashboard_juridique_qos",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Productivité",
          Url: "/new-dashboard/direction-juridique/productivite",
          active: "",
          permission: "new_dashboard_juridique_productivite",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        }
        //
      ]
    },

    
    {
      title: "Suivi portefeuille",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Portefeuille risque",
          Url: "/new-dashboard/suivi-portefeuille/portefeuille-risque",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Impayé",
          Url: "/new-dashboard/suivi-portefeuille/dossier-impaye",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Créances restructurées",
          Url: "/new-dashboard/suivi-portefeuille/creance-restructure",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        {
          title: "Provision",
          Url: "/new-dashboard/suivi-portefeuille/dossier-provision",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        //
      ]
    },


    
    {
      title: "Audit",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown",
      permission: "new_dashboard_audit",
      header_id: "new_tableau_de_bord",
      current_header: "",
      submenus: [
        //
        {
          title: "Logs",
          Url: "/reporting/historique-log",
          active: "",
          permission: "new_dashboard_audit_logs",
          submenus: null,
          header_id: "new_tableau_de_bord",
          current_header: ""
        },
        //
      ]
    },



    //new

    {
      title: "workflow",
      type: "header",
      permission: "for_all",
      header_id: "workflow",
      current_header: ""
    },

    {
      title: "Activité",
      Url: "/mon-portefeuille/mes-dossiers",
      icon: "fa fa-tasks",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "workflow",
      current_header: ""
    },

    {
      title: "Dossier",
      icon: "fa fa-folder-open",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "workflow",
      current_header: "",
      submenus: [
        //
        {
          title: "Corporate",
          Url: "/cnce-corporate/dossier-historique-all",
          active: "",
          permission: "corporate_historiqueDossier",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Particulier",
          Url: "/retail/dossier-historique-all",
          active: "",
          permission: "particulier_historiqueDossier",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Professionnel",
          Url: "/cnce-professionnel/dossier-historique-all",
          active: "",
          permission: "professionnel_historiqueDossier",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Product Program",
          Url: "/product-program/dossier-historique",
          active: "",
          permission: "product_program",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Contentieux",
          Url: "/contentieux/dossier-historique",
          active: "",
          permission: "contentieux_historiqueDossier",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        }
        //
      ]
    },

    /*{
      title: 'Comité de crédit',
      Url:'/comite-credit/all-comite',
      icon: 'fa fa-calendar',
      active: '',
      permission:'comite_credit',
      type: 'simple',
      submenus:null,
      header_id:'workflow',
      current_header:''
    },*/

    {
      title: "Comité de crédit",
      icon: "fa fa-folder-open",
      active: "",
      type: "dropdown",
      permission: "comite_credit",
      header_id: "workflow",
      current_header: "",
      submenus: [
        {
          title: "Calendrier",
          Url: "/comite-credit/calendrier",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Comité interne",
          Url: "/comite-credit/comite-interne",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Comité supérieur",
          Url: "/comite-credit/comite-superieur",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Comité déclassement",
          Url: "/comite-credit/comite-declassement",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        },
        {
          title: "Etat définitif",
          Url: "/comite-credit/etat-definitif",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "workflow",
          current_header: ""
        }
      ]
    },

    //BI
    {
      title: "BI",
      type: "header",
      permission: "for_all",
      header_id: "bi",
      current_header: ""
    },
    {
      title: "Activité",
      Url: "/reporting/audience",
      icon: "fa fa-line-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "bi",
      current_header: ""
    },
    {
      title: "Reporting",
      icon: "fa fa-print",
      active: "",
      type: "dropdown",
      permission: "reporting",
      header_id: "bi",
      current_header: "",
      submenus: [
        {
          title: "Profil",
          Url: "/reporting/profile",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Direction",
          Url: "/reporting/direction",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Tous les dossiers",
          Url: "/reporting/dossier",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Particulier",
          Url: "/reporting/dossier-particulier",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Corporate",
          Url: "/reporting/dossier-corporate",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Professionnel",
          Url: "/reporting/dossier-professionnel",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        }
      ]
    },
    {
      title: "Audit",
      icon: "fa fa-search",
      active: "",
      type: "dropdown",
      permission: "audit",
      header_id: "bi",
      current_header: "",
      submenus: [
        {
          title: "Logs",
          Url: "/reporting/historique-log",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "bi",
          current_header: ""
        }
      ]
    },

    /*{
      title: "Historique des clients",
      icon: "fa fa-group",
      active: "",
      type: "dropdown",
      permission: "historique_client",
      header_id: "bi",
      current_header: "",
      submenus: [
        {
          title: "Corporate",
          Url: "/historique-client/corporate",
          active: "",
          permission: "historique_client",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Particulier",
          Url: "/historique-client/particulier",
          active: "",
          permission: "historique_client",
          submenus: null,
          header_id: "bi",
          current_header: ""
        },
        {
          title: "Professionnel",
          Url: "/historique-client/professionnel",
          active: "",
          permission: "historique_client",
          submenus: null,
          header_id: "bi",
          current_header: ""
        }
      ]
    },*/

    //BI

    {
      title: "Suivi portefeuille",
      type: "header",
      permission: "for_all",
      header_id: "suivi-portefeuille",
      current_header: ""
    },
    {
      title: "Historique importation",
      Url: "/suivi-portefeuille/historique-importation",
      icon: "fa fa-cloud-upload",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "suivi-portefeuille",
      current_header: ""
    },
    {
      title: "Vue portefeuille",
      Url: "/suivi-portefeuille/vue-portefeuille",
      icon: "fa fa-money",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "suivi-portefeuille",
      current_header: ""
    },
    {
      title: "Provisions",
      Url: "/suivi-portefeuille/provisions",
      icon: "fa fa-dollar",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "suivi-portefeuille",
      current_header: ""
    },
   /* {
      title: "Compte client",
      icon: "fa fa-bank",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "suivi-portefeuille",
      current_header: "",
      submenus: [
        {
          title: "Tous les clients",
          Url: "/suivi-portefeuille/comptes",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "suivi-portefeuille",
          current_header: ""
        },
        {
          title: "Gestionnaire",
          Url: "/suivi-portefeuille/comptes-by-gestionnaire",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "suivi-portefeuille",
          current_header: ""
        }
      ]
    },*/

    /*{
		  title: 'Dossier de crédit',
		  Url:'/suivi-portefeuille/dossiers',
		  icon: 'fa fa-money',
		  active: '',
		  permission:'for_all',
		  type: 'simple',
		  submenus:null,
		  header_id:'suivi-portefeuille',
		  current_header:''
    },*/

    /*{
      title: "Dossier de crédit",
      icon: "fa fa-money",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "suivi-portefeuille",
      current_header: "",
      submenus: [
        {
          title: "Tous les dossiers",
          Url: "/suivi-portefeuille/dossiers",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "suivi-portefeuille",
          current_header: ""
        },
        {
          title: "Gestionnaire",
          Url: "/suivi-portefeuille/dossiers-by-gestionnaire",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "suivi-portefeuille",
          current_header: ""
        }
      ]
    },*/

    //Fonds propres
    {
      title: "Fonds propres",
      type: "header",
      permission: "for_all",
      header_id: "fonds_propres",
      current_header: ""
    },
    {
      title: "Portefeuilles",
      icon: "fa fa-google-wallet",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "fonds_propres",
      current_header: "",
      submenus: [
        {
          title: "Importations",
          Url: "/fonds-propres/importations",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Pilotage FP",
          Url: "/fonds-propres/portefeuilles/portefeuille-details",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Rapports",
          Url: "/fonds-propres/portefeuilles",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        }
      ]
    },

    {
      title: "Correspondances",
      icon: "fa fa-dot-circle-o",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "fonds_propres",
      current_header: "",
      submenus: [
        {
          title: "Notations",
          Url: "/fonds-propres/parametres/parametre-notation",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Segmentations prudentielles",
          Url: "/fonds-propres/parametres/segmentations-prudentielles",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        }
      ]
    },
    {
      title: "Paramétrage",
      icon: "fa fa-cog",
      active: "",
      type: "dropdown",
      permission: "for_all",
      header_id: "fonds_propres",
      current_header: "",
      submenus: [
        {
          title: "Notations",
          Url: "/fonds-propres/parametres/parametre-notation",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Entités pondérées",
          Url: "/fonds-propres/parametres/entity-ponderee",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Paramètres pondérés",
          Url: "/fonds-propres/parametres/parametre-pondere",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Types financement",
          Url: "/fonds-propres/parametres/type-financement",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Types garanties",
          Url: "/fonds-propres/parametres/type-garantie",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Règles de gestion",
          Url: "/fonds-propres/parametres/rule-management",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Segmentations prudentielles",
          Url: "/fonds-propres/parametres/segmentations-prudentielles",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        },
        {
          title: "Paramètres",
          Url: "/fonds-propres/parametres/parametre-general",
          active: "",
          permission: "for_all",
          submenus: null,
          header_id: "fonds_propres",
          current_header: ""
        }
      ]
    },

    //Fin Fonds propres

    //Client
    {
      title: "Gestion client",
      type: "header",
      permission: "for_all",
      header_id: "client",
      current_header: ""
    },
    {
      title: "Client",
      Url: "/crm/client",
      icon: "fa fa-book",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "client",
      current_header: ""
    },

    {
      title: "Tous les Clients",
      Url: "/crm/client-all",
      icon: "fa fa-book",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "client",
      current_header: ""
    },

    {
      title: "Importations",
      Url: "/crm/importation-transactions",
      icon: "fa fa-book",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "client",
      current_header: ""
    },

    // FIn client
    {
      title: "Support client",
      type: "header",
      permission: "for_all",
      header_id: "support-client",
      current_header: ""
    },
    {
      title: "Contact",
      Url: "/support-client/contact-support-client",
      icon: "fa fa-book",
      active: "",
      permission: "for_all",
      type: "simple",
      submenus: null,
      header_id: "support-client",
      current_header: ""
    },
    {
		  title: 'Manuel utilisateur',
		  icon: 'fa fa-book',
		  active: '',
		  type: 'dropdown',
		  permission:'for_all',
		  header_id:'support-client',
		  current_header:'',
		  submenus: [
			  {
				  title: 'Paramétrage compte utilisateur',
				  Url:'/support-client/manuel-parametrage-utlisateur',
				  active: '',
				  permission:'for_all',
				  submenus:null,
				  header_id:'support-client',
				  current_header:''
			  },
			  
		  ]
    },
    {
		  title: 'Memo employeur',
		  Url:'/support-client/memo-employeur',
		  icon: 'fa fa-book',
		  active: '',
		  permission:'for_all',
		  type: 'simple',
		  submenus:null,
		  header_id:'support-client',
		  current_header:''
    },
    
  ];

  constructor() {}

  toggle() {
    this.toggled = !this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getMenuList() {
    return this.menus;
  }

  toggleActiveLink() {
    const link = String(window.location.href);

    this.menus.forEach(element => {
      element.active = "";

      /**
       *
       */
      if (element.type === "dropdown") {
        let currentMenu = null;
        let subMenu = element.submenus.find(
          y => window.location.origin + "/#" + y.Url == link
        );

        if (subMenu != null) {
          currentMenu = element;

          currentMenu.submenus.forEach(elem => {
            if (elem === subMenu) {
              currentMenu.active = "open";
              subMenu.active = "active";
            } else {
              elem.active = "";
            }
          });
        }
      }
      /**
       *
       */
      if (
        element.type === "simple" &&
        window.location.origin + "/#" + element.Url === link
      ) {
        element.active = "open";
      }
      /**
       *
       */
      if (element.type === "dropdown_l3") {
        element.submenus.forEach(elem => {
          let currentMenu = null;
          let currentMenu1 = null;
          let subMenu = null;

          if (elem.submenus != null) {
            subMenu = elem.submenus.find(
              y => window.location.origin + "/#" + y.Url == link
            );

            if (subMenu != null) {
              currentMenu = element;
              currentMenu1 = elem;

              elem.submenus.forEach(ele => {
                if (ele === subMenu) {
                  currentMenu.active = "open";
                  currentMenu1.active = "open";
                  ele.active = "active";
                } else {
                  ele.active = "";
                }
              });
            }
          } else {
            let subM = element.submenus.find(
              y => window.location.origin + "/#" + y.Url == link
            );
            currentMenu = element;
            element.submenus.forEach(elem => {
              if (elem === subM) {
                currentMenu.active = "open";
                subM.active = "active";
              } else {
                elem.active = "";
              }
            });
          }
        });
      }
    });
  }
}